export const _static_messages = {
    DEFAULT  : "Something Went Wrong!",
    DISPATCH_FILES  : "Successfully file uploaded to server",
    SEND_MAIL: "Email sent successfully",
    SUCESS:"Manual Match Successful"
}